<template>
  <div class="container">
      <main>
            <Search @getInputValue='getInputValue' @search='search' @add='add'>销售公司</Search>
            <el-table
                :data="list"
                header-align="center"
                :row-class-name="TableRowClassName"
                style="width:100%;padding:0 0px;height:100%"
                :header-cell-style="{ background: '#EBEEF8',height: '45px' }"
                :cell-style="{padding:'0px'}"
            >
            <el-table-column
            label="序号"
            type="index"
            :index="indexMethod"
            align="center"
            >
            </el-table-column>
            <el-table-column
            prop="name"
            label="公司名称"
            align="center"
            show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
            prop="shortName"
            label="内部简称"
            align="center"
            show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
            prop="linker"
            label="负责人"
            align="center"
            show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
            prop="linkerTel"
            label="负责人电话"
            align="center"
            show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
            prop="remark"
            label="备注"
            align="center"
            show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
            label="操作"
            align="center"
            fixed="right"
            min-width="80"
            width="80"
            >
                <template slot-scope="scope">
                    <div style="display:flex;width:100%;justify-content:space-around">
                        <el-button @click="edit(scope.row)" type="text" size="mini" class="btn">
                            <i class="el-icon-edit-outline" style="fontSize:19px;color:#000"></i>
                        </el-button>
                    </div>
                </template>
            </el-table-column>
            </el-table>
            <Pagination :pageTotal="pageTotal" @currentPage="currentPage"/>
        </main>
        <el-dialog :title="isEdit?'编辑':'新增'"  :visible.sync="dialogFormVisible" center :close-on-click-modal="false" style="width:60%;margin:0 auto;marginTop:-50px">
            <div class="dialogline"></div>
                <el-form :model="dialogForm" class="dialogForm" :rules="formRules" ref="formRules">
                    <el-form-item label="公司名称" label-width="90px" prop="name">
                        <el-input @change="companyChange" v-model="dialogForm.name" autocomplete="off" placeholder="请输入公司名称" ></el-input>
                    </el-form-item>
                    <el-form-item label="内部简称" label-width="90px" prop="shortName" >
                        <el-input v-model="dialogForm.shortName" autocomplete="off" placeholder="请输入内部简称" ></el-input>
                    </el-form-item>
                    <el-form-item label="负责人员" label-width="90px" prop="linker" >
                        <el-input v-model="dialogForm.linker" autocomplete="off" placeholder="请输入负责人" ></el-input>
                    </el-form-item>
                    <el-form-item label="联系电话" label-width="90px" prop="linkerTel" >
                        <el-input v-model="dialogForm.linkerTel" autocomplete="off" placeholder="请输入负责人电话" ></el-input>
                    </el-form-item>
                    <el-form-item label="备注信息" label-width="90px" prop="remark" >
                        <el-input type="textarea" :rows="3" v-model="dialogForm.remark" autocomplete="off" placeholder="添加备注信息" ></el-input>
                    </el-form-item>
                </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmForm">{{isEdit?'保 存':'确 定'}}</el-button>
            </div>
        </el-dialog>
  </div>
</template>

<script>
export default {
    data(){
        return{
            option: {
                filter: '',
                pageSize: 15,
                pageIndex: 1
            },
            dialogForm: {
                id: 0,
                name: '',
                shortName: '',
                linker: '',
                linkerTel: '',
                remark: ''
            },
            formRules:{
                name:[{
                    required: true,
                    message: "请输入公司名称",
                    trigger: "blur"
                }],
                shortName:[{
                    required: true,
                    message: "请输入公司内部简称",
                    trigger: "blur"
                }],
                linker:[{
                    required: true,
                    message: "请输入负责人姓名",
                    trigger: "blur"
                }],
            },
            pageTotal: 1,
            isEdit: false,
            dialogFormVisible: false,
            list: [],
            inputValue: '',
        }
    },
    methods:{
        //获取list
        getList(option){
            this.$api.SalesCompanyList(option).then(res=>{
                this.list = res.data.data.data;
                this.pageTotal = res.data.data.total;
            })
        },
        //获取页码
        currentPage(option){
            this.option.pageIndex = option
            this.getList(this.option);
        },
        //表格前编号
        indexMethod(index) {
            return index+1 ;
        },
        //表格隔行变色，样式在app.vue里
        TableRowClassName({row,rowIndex}){
            if(rowIndex%2 != 0){
                return 'backtablegray'
            }else{
                return 'backtablewhite'
            }
        },
        //获取搜索框值
        getInputValue(option){
            this.inputValue = option
        },
        //搜索按钮
        search(){
            this.getList({
                filter: this.inputValue,
                pageSize: 15,
                pageIndex: 1
            });
        },
        //公司名称改变
        companyChange(val){
            this.dialogForm.shortName = val;
        },
        //添加按钮
        add(){
            this.isEdit = false;
            this.dialogFormVisible = true;
            this.dialogForm = {
                id: 0,
                name: '',
                shortName: '',
                linker: '',
                linkerTel: '',
                remark: ''
            };
        },
        //编辑按钮
        edit(row) {
            this.isEdit = true;
            this.dialogFormVisible = true;
            this.dialogForm = {
                id: row.id,
                name: row.name,
                shortName: row.shortName,
                linker: row.linker,
                linkerTel: row.linkerTel,
                remark: row.remark
            };
        },
        //dialog提交按钮
        confirmForm(){
            this.$refs.formRules.validate(valid=>{
                if(valid){
                    //可以提交
                    if(this.isEdit){
                        this.$api.UpdateSalesCompany(this.dialogForm).then(res=>{
                            if(res.data.code == 200){
                                this.getList(this.option);
                                this.$notify({
                                    message: res.data.msg,
                                    type: 'success'
                                })
                            }else{
                                this.$notify({
                                    message: res.data.msg,
                                    type: 'error'
                                })
                            }
                        })
                    }else{
                        this.$api.AddSalesCompany(this.dialogForm).then(res=>{
                            if(res.data.code == 200){
                                this.getList(this.option);
                                this.$notify({
                                    message: res.data.msg,
                                    type: 'success'
                                })
                            }else{
                                this.$notify({
                                    message: res.data.msg,
                                    type: 'error'
                                })
                            }
                        })
                    }
                    this.dialogFormVisible = false;
                }else{
                    return false
                }
            })
        }
    },
    mounted(){
        this.getList(this.option);
    }
}
</script>

<style lang='scss' scoped>
.container{
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
}
main{
    overflow: hidden;
    background: #fff;
    display: flex;
    flex-direction: column;
    flex: 1;
    padding: 0 8px;
}
</style>